import React, { Component } from "react";
import { Link } from "react-router-dom";

class Service extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slidecard: [
        {
          id: 1,
          srcimg: "assets/img/imagebox/image-box-1-370x250.jpeg",
          heading: "PLYWOOD & BOARDS INVENTORY",
        },
        {
          id: 2,
          srcimg: "assets/img/imagebox/image-box-2-370x250.jpeg",
          heading: "HARDWARE & FASTENERS",
        },
        {
          id: 3,
          srcimg: "assets/img/imagebox/image-box-3-370x250.jpeg",
          heading: "CUSTOMER SERVICE",
        },
        {
          id: 4,
          srcimg: "assets/img/imagebox/image-box-4-370x250.jpeg",
          heading: "SHOP SIGNAGE",
        },
        {
          id: 5,
          srcimg: "assets/img/imagebox/image-box-5-370x250.jpeg",
          heading: "BULK PLYWOOD SUPPLY",
        },
        {
          id: 6,
          srcimg: "assets/img/imagebox/image-box-6-370x250.jpeg",
          heading: "WHOLESALE MATERIALS",
        },
        // {
        //   id: 7,
        //   srcimg:
        //     "assets/img/imagebox/WhatsApp Image 2025-12-11 at 10.25.42 (1).jpeg",
        //   heading: "BULK SUPPLY",
        // },
      ],
    };
  }

  render() {
    return (
      <div
        className="themesflat-carousel-box data-effect clearfix"
        data-gap={30}
        data-column={3}
        data-column2={2}
        data-column3={1}
        data-auto="false"
      >
        <div className="owl-carousel owl-theme">
          {this.state.slidecard.map((data) => (
            <div
              className="themesflat-image-box style-1 has-icon icon-right w65 clearfix"
              key={data.id}
            >
              <div className="image-box-item">
                <div className="inner">
                  <div className="thumb data-effect-item">
                    <img src={data.srcimg} alt="altimage" />
                    <div className="overlay-effect bg-color-accent" />
                  </div>
                  <div className="text-wrap">
                    <h5 className="heading">
                      <Link to="#">{data.heading}</Link>
                    </h5>
                    <span className="icon-wrap">
                      <i className="fa fa-angle-right" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default Service;
